import PurchaseIcon from '@material-ui/icons/ShoppingCart';
import PurchaseList from './PurchaseList';
import PurchaseCreate from './PurchaseCreate';

export default {
    list: PurchaseList,
    create: PurchaseCreate,
    icon: PurchaseIcon,
};
